'use client';

import Link from 'next/link';
import { ClockIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { trackEvent } from '../../../lib/analytics/posthog';
import { EVENTS } from '../../../lib/analytics/events';
import { getSeoPrice } from '@utils/seo-locale';
import { formatPrice } from '@utils/price';
import { vendorStorefrontUrl } from '@utils/storefront-url';

export default function ServiceCard({ vendor, service, index = 0, campaign = 'vendor_profile' }) {
  const isRealVendor = !vendor.is_created_by_marketplace;
  const href = isRealVendor
    ? vendorStorefrontUrl(vendor.username, { serviceSlug: service.slug, campaign, content: 'service_card' })
    : `/negocios/${vendor.username}/servicios/${service.slug}`;
  const { currency, price } = getSeoPrice(service, vendor.country);
  const showPrice = !service.is_price_hidden && Number(price) > 0;
  const showDuration = !service.is_duration_hidden && Number(service.duration) > 0;

  return (
    <a
      href={href}
      className="group block animate-card-enter"
      onClick={() => trackEvent(EVENTS.VENDOR_SERVICE_CLICKED, { vendor_username: vendor.username, service_name: service.name, position: index })}
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="flex items-center justify-between gap-4 p-4 rounded-xl bg-white border border-gray-100 hover:border-gray-200 hover:shadow-sm transition-all duration-200">
        {/* Service info */}
        <div className="flex-1 min-w-0">
          {/* Hasta dos líneas: «Retoque Micropigmentación de cejas» y «… de labios» no pueden leerse igual */}
          <h3 className="text-[15px] font-semibold leading-snug text-[#1a1a1a] group-hover:text-primary-600 transition-colors line-clamp-2 break-words">
            {service.name}
          </h3>
          {(showDuration || showPrice) && (
            <div className="flex items-center gap-3 mt-1.5">
              {showDuration && (
                <span className="inline-flex items-center gap-1 text-[12px] text-gray-500 font-medium">
                  <ClockIcon className="w-3.5 h-3.5" />
                  {service.duration} min
                </span>
              )}
              {showDuration && showPrice && <span className="text-gray-200" aria-hidden="true">|</span>}
              {showPrice && (
                <span className="text-[13px] font-semibold text-[#1a1a1a] tabular-nums">
                  {formatPrice(price, currency)}
                </span>
              )}
            </div>
          )}
        </div>

        {/* CTA */}
        {isRealVendor ? (
          <span className="flex-shrink-0 px-3 py-1.5 rounded-lg bg-primary-500 text-white text-[12px] font-medium group-hover:bg-primary-600 transition-colors">
            Reservar
          </span>
        ) : (
          <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-gray-50 group-hover:bg-primary-50 flex items-center justify-center transition-colors">
            <ChevronRightIcon className="w-4 h-4 text-gray-400 group-hover:text-primary-500 transition-colors" />
          </div>
        )}
      </div>
    </a>
  );
}
